module.exports = __webpack_public_path__ + "img/319.e05cb823.png";